import { VCol } from 'vuetify/lib/components/VGrid';
import { VRow } from 'vuetify/lib/components/VGrid';

var render = function render(){var _vm=this,_c=_vm._self._c;return _c(VRow,[_c(VCol,{class:_vm.tab && 'px-0 pt-0'},[_vm._t("default")],2)],1)
}
var staticRenderFns = []

export { render, staticRenderFns }